import { useMemo } from "react";
import { useSelector } from "react-redux";
import companySelectors from "store/selectors/company";

export type NameHook = string;

/**
 * Returns the current company name to be displayed
 */
export default function useName(isLoading = false): NameHook {
  const company = useSelector(companySelectors.getEntity);

  const name = useMemo<NameHook>(() => {
    if (isLoading) return "";
    if (company?.company_type === "sole_trader")
      return company?.sole_trader_info?.trading_name || "No trading name";
    return company?.limited_company_info?.company_name || "No company name";
  }, [company, isLoading]);

  return name;
}
